import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { CustomFieldsAccessLayout } from 'pages/settings/pages/customFields/layout/CustomFieldsAccessLayout'
import { CustomFieldsPage } from 'pages/settings/pages/customFields/ui/CustomFieldsPage'

export const CustomFieldsRouter = observer(() => {
  return (
    <Routes>
      <Route element={<CustomFieldsAccessLayout />}>
        <Route index element={<CustomFieldsPage />} />
      </Route>
    </Routes>
  )
})
